import { animate, animation, style } from '@angular/animations';

export const fadeIn = animation(
  [
    style({
      opacity: 0,
    }),
    animate(
      '{{ duration }}ms {{ delay }}ms {{ easing }}',
      style({
        opacity: 1,
      }),
    ),
  ],
  {
    params: {
      duration: '200',
      delay: '0',
      easing: 'ease-out',
    },
  },
);
